var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkoejtebane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.114,9.658c0-.025,0-.05,0-.075a1.014,1.014,0,0,0-.307-.53,1.06,1.06,0,0,0-.551-.266,6.685,6.685,0,0,1-2.7-1.237,5.6,5.6,0,0,1-2.27-3.894A.533.533,0,0,0,6.761,3.2H6.753L4,3.343a.536.536,0,0,0-.543.537v.006l.249,4.521a1.146,1.146,0,0,1-.006.2l-.131,2v.012a.538.538,0,0,0,.537.537h.541l-.357.777H3.226a.265.265,0,0,0,0,.53H11.4A1.767,1.767,0,0,0,13.168,10.7l.039-.852A.255.255,0,0,0,13.114,9.658ZM4.859,11.936l.357-.777h.8a.534.534,0,0,0,.537-.519l.01-.295.615.647a.541.541,0,0,0,.39.167H8.929l.364.777Zm6.543,0H9.862L9.5,11.159h2.271a1.039,1.039,0,0,0,.585-.178,2.339,2.339,0,0,0,.274-.226A1.233,1.233,0,0,1,11.4,11.936Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkoejtebane);
export default __webpack_public_path__ + "static/media/SKOEJTEBANE.38c0b85d05ad493c4f838386623c876f.svg";
export { ForwardRef as ReactComponent };